import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/leistungen/bg_hand_herz.png";

import Image from "../../images/leistungen/ergometrie.jpg"

const Ergometrie = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> ERGOMETRIE-Belastungs </h1>
                    <img src={Image} style={{float: "right", margin:"15px"}}/>
                    <p className="page-text">
                    Unter einer Ergometrie versteht man einen <b>zu Diagnosezwecken stufenförmig ansteigenden körperlichen Belastungstest auf einem dafür geeigneten und geeichten Testgerät</b>, einem sog. Ergometer. Für den Laien geläufiger ist der Begriff <b>Belastungs-EKG</b>, da eine Ergometrie in der Regel unter EKG-Kontrolle erfolgt. Das EKG (= Elektro-Kardiogramm) zeichnet die Herzstromkurve auf.
                    <br /> <br />
                    In der Praxis wird meist das Fahrradergometer verwendet, seltener das Laufbandergometer. Im Hochleistungssport kommen noch andere (sportartspezifische) Ergometer zur Anwendung.
                    <br /> <br />
                    Die Ergometrie wird nach einem <b>Stufenprotokoll</b> durchgeführt, wobei dieses frei programmierbar ist. Vorgegeben werden die Stufendauer (in Minuten) und die Belastungssteigerung pro Stufe (beim Fahrradergometer in Watt).
                    <br /> <br />
                    Das in Österreich gängige Stufenprotokoll der Fahrradergometrie beginnt mit einer Belastung von 25 oder 50 Watt mit einer Laststeigerung von 25 Watt alle 2 Minuten. Dies ist das üliche WHO-Protokoll, das bei PatientInnen zur Anwendung kommt.
                    </p>
                    <p className="page-text" style={{"background-color":"rgb(202, 194, 194)", "padding":"15px"}}>
                        <h3>Wichtig für die Untersuchung</h3>
                        Bitte bringen Sie zum Belastungstest bequeme Kleidung (Sporthose, Sportschuhe, etc.) und ein Handtuch mit. Die Aussagekraft dieser Untersuchung hängt von der erbrachten Leistung ab. 85% bis 100% Leistung (oder mehr) sind optimal.
                    </p>
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Ergometrie;